export function KeyboardHint() {
  return (
    <p className="text-center text-xs text-muted-foreground">Press Enter to continue, Escape to go back.</p>
  );
}
